/**
 * HTTP Codes
 */
export enum HTTP_CODES {
    OFFLINE = -1,
    INTERNAl = 0,

    CONTINUE = 100,
    SWITCHING_PROTOCOLS = 101,
    PROCESSING = 102,

    OK = 200,
    CREATED = 201,
    ACCEPTED = 202,
    NON_AUTHORITATIVE_INFORMATION = 203,
    NO_CONTENT = 204,
    RESET_CONTENT = 205,
    PARTIAL_CONTENT = 206,
    MULTI_STATUS = 207,
    ALREADY_REPORTED = 208,
    IM_USED = 226,

    MULTIPLE_CHOICES = 300,
    MOVED_PERMANENTLY = 301,
    FOUND = 302,
    SEE_OTHER = 303,
    NOT_MODIFIED = 304,
    USE_PROXY = 305,
    UNUSED = 306,
    TEMPORARY_REDIRECT = 307,
    PERMANENT_REDIRECT = 308,

    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    PAYMENT_REQUIRED = 402,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    METHOD_NOT_ALLOWED = 405,
    NOT_ACCEPTABLE = 406,
    PROXY_AUTHENTICATION_REQUIRED = 407,
    REQUEST_TIMEOUT = 408,
    CONFLICT = 409,
    GONE = 410,
    LENGTH_REQUIRED = 411,
    PRECONDITION_FAILED = 412,
    REQUEST_ENTITY_TOO_LARGE = 413,
    REQUEST_URI_TOO_LONG = 414,
    UNSUPPORTED_MEDIA_TYPE = 415,
    REQUESTED_RANGE_NOT_SATISFIABLE = 416,
    EXPECTATION_FAILED = 417,
    UNPROCESSABLE_ENTITY = 422,
    LOCKED = 423,
    FAILED_DEPENDENCY = 424,
    UPGRADE_REQUIRED = 426,
    PRECONDITION_REQUIRED = 428,
    TOO_MANY_REQUESTS = 429,
    REQUEST_HEADER_FIELDS_TOO_LARGE = 431,
    NO_RESPONSE = 444,
    CLIENT_CLOSED_REQUEST = 499,

    INTERNAL_SERVER_ERROR = 500,
    NOT_IMPLEMENTED = 501,
    BAD_GATEWAY = 502,
    SERVICE_UNAVAILABLE = 503,
    GATEWAY_TIMEOUT = 504,
    VERSION_NOT_SUPPORTED = 505,
    VARIANT_ALSO_NEGOTIATES = 506,
    INSUFFICIENT_STORAGE = 507,
    LOOP_DETECTED = 508,
    BANDWIDTH_LIMIT_EXCEEDED = 509,
    NOT_EXTENDED = 510,
    NETWORK_AUTHENTICATION_REQUIRED = 511,
}

/**
 * HTTP Codes & Messages
 */
export class HTTPCodes {
    static HTTP_100 = 'Continue';
    static HTTP_CONTINUE = 100;
    static HTTP_101 = 'Switching Protocols';
    static HTTP_SWITCHING_PROTOCOLS = 101;
    static HTTP_102 = 'Processing';
    static HTTP_PROCESSING = 102;

    static HTTP_200 = 'OK';
    static HTTP_OK = 200;
    static HTTP_201 = 'Created';
    static HTTP_CREATED = 201;
    static HTTP_202 = 'Accepted';
    static HTTP_ACCEPTED = 202;
    static HTTP_203 = 'Non-Authoritative Information';
    static HTTP_NON_AUTHORITATIVE_INFORMATION = 203;
    static HTTP_204 = 'No Content';
    static HTTP_NO_CONTENT = 204;
    static HTTP_205 = 'Reset Content';
    static HTTP_RESET_CONTENT = 205;
    static HTTP_206 = 'Partial Content';
    static HTTP_PARTIAL_CONTENT = 206;
    static HTTP_207 = 'Multi-Status';
    static HTTP_MULTI_STATUS = 207;
    static HTTP_208 = 'Already Reported';
    static HTTP_ALREADY_REPORTED = 208;
    static HTTP_226 = 'IM Used';
    static HTTP_IM_USED = 226;

    static HTTP_300 = 'Multiple Choices';
    static HTTP_MULTIPLE_CHOICES = 300;
    static HTTP_301 = 'Moved Permanently';
    static HTTP_MOVED_PERMANENTLY = 301;
    static HTTP_302 = 'Found';
    static HTTP_FOUND = 302;
    static HTTP_303 = 'See Other';
    static HTTP_SEE_OTHER = 303;
    static HTTP_304 = 'Not Modified';
    static HTTP_NOT_MODIFIED = 304;
    static HTTP_305 = 'Use Proxy';
    static HTTP_USE_PROXY = 305;
    static HTTP_306 = 'Unused';
    static HTTP_UNUSED = 306;
    static HTTP_307 = 'Temporary Redirect';
    static HTTP_TEMPORARY_REDIRECT = 307;
    static HTTP_308 = 'Permanent Redirect';
    static HTTP_PERMANENT_REDIRECT = 308;

    static HTTP_400 = 'Bad Request';
    static HTTP_BAD_REQUEST = 400;
    static HTTP_401 = 'Unauthorized';
    static HTTP_UNAUTHORIZED = 401;
    static HTTP_402 = 'Payment Required';
    static HTTP_PAYMENT_REQUIRED = 402;
    static HTTP_403 = 'Forbidden';
    static HTTP_FORBIDDEN = 403;
    static HTTP_404 = 'Not Found';
    static HTTP_NOT_FOUND = 404;
    static HTTP_405 = 'Method Not Allowed';
    static HTTP_METHOD_NOT_ALLOWED = 405;
    static HTTP_406 = 'Not Acceptable';
    static HTTP_NOT_ACCEPTABLE = 406;
    static HTTP_407 = 'Proxy Authentication Required';
    static HTTP_PROXY_AUTHENTICATION_REQUIRED = 407;
    static HTTP_408 = 'Request Timeout';
    static HTTP_REQUEST_TIMEOUT = 408;
    static HTTP_409 = 'Conflict';
    static HTTP_CONFLICT = 409;
    static HTTP_410 = 'Gone';
    static HTTP_GONE = 410;
    static HTTP_411 = 'Length Required';
    static HTTP_LENGTH_REQUIRED = 411;
    static HTTP_412 = 'Precondition Failed';
    static HTTP_PRECONDITION_FAILED = 412;
    static HTTP_413 = 'Request Entity Too Large';
    static HTTP_REQUEST_ENTITY_TOO_LARGE = 413;
    static HTTP_414 = 'Request-URI Too Long';
    static HTTP_REQUEST_URI_TOO_LONG = 414;
    static HTTP_415 = 'Unsupported Media Type';
    static HTTP_UNSUPPORTED_MEDIA_TYPE = 415;
    static HTTP_416 = 'Requested Range Not Satisfiable';
    static HTTP_REQUESTED_RANGE_NOT_SATISFIABLE = 416;
    static HTTP_417 = 'Expectation Failed';
    static HTTP_EXPECTATION_FAILED = 417;
    static HTTP_422 = 'Unprocessable Entity';
    static HTTP_UNPROCESSABLE_ENTITY = 422;
    static HTTP_423 = 'Locked';
    static HTTP_LOCKED = 423;
    static HTTP_424 = 'Failed Dependency';
    static HTTP_FAILED_DEPENDENCY = 424;
    static HTTP_426 = 'Upgrade Required';
    static HTTP_UPGRADE_REQUIRED = 426;
    static HTTP_428 = 'Precondition Required';
    static HTTP_PRECONDITION_REQUIRED = 428;
    static HTTP_429 = 'Too Many Requests';
    static HTTP_TOO_MANY_REQUESTS = 429;
    static HTTP_431 = 'Request Header Fields Too Large';
    static HTTP_REQUEST_HEADER_FIELDS_TOO_LARGE = 431;
    static HTTP_444 = 'No Response';
    static HTTP_NO_RESPONSE = 444;
    static HTTP_499 = 'Client Closed Request';
    static HTTP_CLIENT_CLOSED_REQUEST = 499;

    static HTTP_500 = 'Internal Server Error';
    static HTTP_INTERNAL_SERVER_ERROR = 500;
    static HTTP_501 = 'Not Implemented';
    static HTTP_NOT_IMPLEMENTED = 501;
    static HTTP_502 = 'Bad Gateway';
    static HTTP_BAD_GATEWAY = 502;
    static HTTP_503 = 'Service Unavailable';
    static HTTP_SERVICE_UNAVAILABLE = 503;
    static HTTP_504 = 'Gateway Timeout';
    static HTTP_GATEWAY_TIMEOUT = 504;
    static HTTP_505 = 'HTTP Version Not Supported';
    static HTTP_VERSION_NOT_SUPPORTED = 505;
    static HTTP_506 = 'Variant Also Negotiates';
    static HTTP_VARIANT_ALSO_NEGOTIATES = 506;
    static HTTP_507 = 'Insufficient Storage';
    static HTTP_INSUFFICIENT_STORAGE = 507;
    static HTTP_508 = 'Loop Detected';
    static HTTP_LOOP_DETECTED = 508;
    static HTTP_509 = 'Bandwidth Limit Exceeded';
    static HTTP_BANDWIDTH_LIMIT_EXCEEDED = 509;
    static HTTP_510 = 'Not Extended';
    static HTTP_NOT_EXTENDED = 510;
    static HTTP_511 = 'Network Authentication Required';
    static HTTP_NETWORK_AUTHENTICATION_REQUIRED = 511;
}
